/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Button from "components/CustomButtons/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import isEmpty from "lodash/isEmpty";
import {
  ErrorMessage, Field, Form, Formik,
} from "formik";
import Card from "components/Card/Card";
import styles from "assets/jss/material-dashboard-react/components/businessForm";
import viking from "../../assets/img/vikingstransparent_logo.png";
import CommonDialog from "../../components/DialogBox/Common";
import Validations from "../../Utils/Validations";
import { profileCodePermissionCheck } from "../../Utils/commonUtils";

// Create custom styles using Material-UI's makeStyles
const useStyles = makeStyles(styles);

const ChangePassword = props => {
  // State to track the forgetPassword value from props
  const [preForgetPassword, setPrePassword] = React.useState(
    props.formData.forgetPassword
  );

  // State to track the status of the password change call
  const [callStatus, setCallStatus] = React.useState("");

  // Initialize styles
  const classes = useStyles();

  // Handle dialog close and navigate based on profile code
  const onClose = () => {
    setCallStatus("");
    if (props?.formData?.changePassword?.data === profileCodePermissionCheck.profileCode.VCS) {
      props.history.push("/admin/login"); // Navigate to admin login
    } else {
      props.history.push("/"); // Navigate to home
    }
  };

  // Effect to update the forgetPassword state if props change
  React.useState(() => {
    if (preForgetPassword !== props.formData.forgetPassword) {
      setPrePassword(props.formData.forgetPassword);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Effect to update call status when changePassword status or message changes
  React.useEffect(() => {
    if (
      props.formData.changePassword.status
      && props.formData.changePassword.message
    ) {
      setCallStatus(props.formData.changePassword.message);
    }
  }, [props]);

  // Handle form submission to change the password
  const onFormSubmit = values => {
    const data = {
      userId: props.formData.userIdForgetPassword
        ? props.formData.userIdForgetPassword
        : props.formData.authTokenCheck.data, // Determine user ID
      password: values.password, // New password
    };
    props.changePasswordCall(data); // Call the change password function
  };

  return (
    <Card style={{ width: "35%" }}>
      {/* Logo Section */}
      <Grid container style={{ marginTop: "8%" }}>
        <Grid item xs align="center">
          <img src={viking} width="30%" height="auto" alt="" />
        </Grid>
      </Grid>

      {/* Title Section */}
      <Grid container style={{ marginTop: "8%", marginBottom: "1%" }}>
        <Grid
          item
          xs
          align="center"
          style={{ color: "#094d81", fontSize: "18px", fontWeight: "bold" }}
        >
          Change your Password
        </Grid>
      </Grid>

      {/* Form Section */}
      <Formik
        validationSchema={Validations.resetPassword} // Validation schema for the form
        enableReinitialize
        onSubmit={onFormSubmit}
        initialValues={{ password: "", confirmPassword: "" }} // Initial form values
      >
        {({ values, errors }) => (
          <Form>
            {/* Password Field */}
            <Grid container>
              <Grid item xs={2} />
              <Grid item xs={10}>
                <Field
                  as={TextField}
                  error={errors.password}
                  className={classes.root}
                  InputLabelProps={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  label="Password"
                  type="password"
                  name="password"
                  id="password"
                />
                <ErrorMessage name="password">
                  {msg => (
                    <Typography
                      component="span"
                      className="error"
                      variant="body2"
                    >
                      {msg}
                    </Typography>
                  )}
                </ErrorMessage>
              </Grid>
            </Grid>

            {/* Confirm Password Field */}
            <Grid container style={{ marginTop: "2%" }}>
              <Grid item xs={2} />
              <Grid item xs={10}>
                <Field
                  as={TextField}
                  error={errors.confirmPassword}
                  className={classes.root}
                  InputLabelProps={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  label="Confirm Password"
                  type="password"
                  name="confirmPassword"
                  id="confirmPassword"
                />
                <ErrorMessage name="confirmPassword">
                  {msg => (
                    <Typography
                      component="span"
                      className="error"
                      variant="body2"
                    >
                      {msg}
                    </Typography>
                  )}
                </ErrorMessage>
              </Grid>
            </Grid>

            {/* Back to Login Link */}
            <div
              style={{
                paddingTop: "4%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a style={{ color: "#b37029" }} href="/">
                Back to login
              </a>
            </div>

            {/* Submit Button */}
            <Grid
              container
              align="center"
              style={{ marginTop: "6%", marginBottom: "10%" }}
            >
              <Grid item xs textAlign="center">
                <Button
                  variant="contained"
                  disabled={
                    !isEmpty(errors)
                    && values.password !== values.confirmPassword
                  } // Disable button if there are errors or passwords don't match
                  type="submit"
                  size="large"
                >
                  Reset Password
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>

      {/* Dialog to display call status */}
      <CommonDialog
        message={callStatus}
        open={!!callStatus}
        onClose={onClose}
      />
    </Card>
  );
};

// Define prop types for the component
ChangePassword.propTypes = {
  formData: PropTypes.object, // Form data passed as props
  changePasswordCall: PropTypes.func, // Function to handle password change
  history: PropTypes.object, // React Router history object for navigation
};

// Export the component as default
export default ChangePassword;
